module.exports = __webpack_public_path__ + "static/media/vuejs.99867826.svg";